export const NAME = 'accidentBenefit'

export const GET_ACCIDENT = 'clientBenefitsAccidentGet'
export const POST_ACCIDENT = 'clientBenefitsAccidentPost'
